import { useSyncExternalStore } from "react";
import { useThemePreferenceStore } from "@/theme/themeStore";
import type { GeoAnalyticsThemeMode, GeoAnalyticsThemePreference } from "@/theme/tokens";

function subscribeToColorScheme(callback: () => void) {
  if (typeof window === "undefined") {
    return () => undefined;
  }

  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  mediaQuery.addEventListener("change", callback);
  return () => mediaQuery.removeEventListener("change", callback);
}

function getSystemTheme(): GeoAnalyticsThemeMode {
  if (typeof window === "undefined") {
    return "light";
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function resolveThemeMode(
  preference: GeoAnalyticsThemePreference,
  systemTheme: GeoAnalyticsThemeMode
) {
  return preference === "system" ? systemTheme : preference;
}

export function useSystemThemeMode() {
  return useSyncExternalStore<GeoAnalyticsThemeMode>(
    subscribeToColorScheme,
    getSystemTheme,
    () => "light"
  );
}

export function useResolvedThemeMode() {
  const preference = useThemePreferenceStore((state) => state.preference);
  const systemTheme = useSystemThemeMode();

  return resolveThemeMode(preference, systemTheme);
}
